import React, { Component } from 'react'
import Loading from './Loading';
import Room from './Room';
import {RoomContext} from '../Context';
import  Title from './Title';
export default class FeaturedRoom extends Component {
    static contextType  = RoomContext;
    render() {
        let {loading,featuredRooms : rooms} =this.context;
        rooms=rooms.map((room) => {
            return<Room key={room.id} room={room} />
        });
        
        return (
            <section className="featured-rooms">
           <Title title="featured Room"/>
              <div className="featured-rooms-center">
              {loading ? <Loading /> : rooms}

              </div>
            </section>
        )
    }
}
